// import "./WorkingHours.css";

// export default function WorkingHours() {
//   return (
//     <section className="wh-wrapper">
//       <div className="wh-box">

//         {/* LEFT SECTION (IMAGE + TEXT) */}
//         <div className="wh-left">
//           <span className="wh-top-line"></span>
//           <p className="wh-top">ABOUT US</p>

//           <h2 className="wh-title">Working hours</h2>

//           <p className="wh-desc">
//             Rolorem, beatae dolorum, praesentium itaque et quam quaerat.
//           </p>

//           <div className="wh-buttons">
//             <button className="wh-btn-primary">RESERVATION</button>
//             <button className="wh-btn-secondary">CONTACT US</button>
//           </div>
//         </div>

//         {/* RIGHT SECTION (WHITE CARD) */}
//         <div className="wh-right">
//           <div className="wh-card">
//             <p className="wh-card-title">MONDAY TO THURSDAY</p>
//             <p className="wh-hour"><b>07 : 30 AM</b></p>
//             <p className="wh-hour"><b>11 : 00 PM</b></p>

//             <div className="wh-divider"></div>

//             <p className="wh-card-title">FRIDAY TO SUNDAY</p>
//             <p className="wh-hour"><b>07 : 30 AM</b></p>
//             <p className="wh-hour"><b>12 : 00 PM</b></p>
//           </div>
//         </div>

//       </div>
//     </section>
//   );
// }


import "./WorkingHours.css";
import { useEffect, useState } from "react";

export default function WorkingHours() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const checkStatus = () => {
      const hour = new Date().getHours();
      setIsOpen(hour >= 11 && hour < 21); // 11:00 AM – 9:00 PM
    };

    checkStatus();
    const timer = setInterval(checkStatus, 60000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="wh-wrapper">
      <div className="wh-box">

        {/* LEFT SECTION */}
        <div className="wh-left">
          <span className="wh-top-line"></span>
          <p className="wh-top">ABOUT US</p>

          <h2 className="wh-title">Working hours</h2>

          <p className="wh-desc">
            Currently in soft launch, open for lunch and dinner.
          </p>

          {/* 🔔 OPEN / CLOSED INDICATOR */}
          {/* <span className={isOpen ? "open" : "closed"}>
            {isOpen ? "Now Open" : "Currently Closed"}
          </span> */}

          <div className="wh-buttons">
            <button className="wh-btn-primary">RESERVATION</button>
            <button className="wh-btn-secondary">CONTACT US</button>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="wh-right">
          <div className="wh-card">
            <p className="wh-card-title">MONDAY TO THURSDAY</p>
            <p className="wh-hour"><b>11 : 00 AM</b></p>
            <p className="wh-hour"><b>09 : 00 PM</b></p>

            <div className="wh-divider"></div>

            <p className="wh-card-title">FRIDAY TO SUNDAY</p>
            <p className="wh-hour"><b>11 : 00 AM</b></p>
            <p className="wh-hour"><b>09 : 00 PM</b></p>
          </div>
        </div>

      </div>
    </section>
  );
}
